import { DataTable, DataTableRowEditCompleteEvent, DataTableSortEvent } from "primereact/datatable";
import { Column, ColumnEditorOptions } from "primereact/column";
import { useEffect, useState } from "react";
import { CancelledOrders } from "../../models/orders/order-list-model";
 
interface DataTableProps {
  data: CancelledOrders[];
  pageNumber: number;
  pageSize: number;
  NoofRecords: number;
  onPageChange: any;
}
 
const CanceledOrderDatatable: React.FC<DataTableProps> = (props) => {
  const [data, setData] = useState<CancelledOrders[]>([]);
  const [sortField, setSortField] = useState<string>('orderID');
  const [sortOrder, setSortOrder] = useState<1 | -1>(1);
 
  useEffect(() => {
    const sortedData = [...props.data].sort((a, b) => {
      const valueA = a[sortField as keyof CancelledOrders]?.toString().toLowerCase() || '';
      const valueB = b[sortField as keyof CancelledOrders]?.toString().toLowerCase() || '';
 
      if (valueA < valueB) return -1 * sortOrder;
      if (valueA > valueB) return 1 * sortOrder;
      return 0;
    });
    setData(sortedData);
  }, [props.data, sortField, sortOrder]);
 
  const onSort = (e: DataTableSortEvent) => {
    if (sortField === e.sortField) {
      setSortOrder(sortOrder === 1 ? -1 : 1);
    } else {
      setSortField(e.sortField);
      setSortOrder(1);
    }
  };
 
  return (
    <div className="col-12">
      <div className="card border-noround p-2">
        <DataTable
          value={data}
          paginator
          editMode="row"
          rows={props.pageSize}
          rowsPerPageOptions={[5, 10, 25, 50, 100]}
          totalRecords={props.NoofRecords}
          lazy
          paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
          currentPageReportTemplate={'{first} to {last} of {totalRecords}'}
          first={(props.pageNumber - 1) * props.pageSize}
          onPage={props.onPageChange}
          sortMode="single"
          sortField={sortField}
          sortOrder={sortOrder}
          onSort={onSort}
        >
          <Column
            field="orderID"
            header="Order#"  
            style={{ width: "12%" }}
            sortable
          />
          <Column
            field="primaryContactNbr"
            header="Primary Contact"  
            style={{ width: "12%" }}
            sortable
          />
          <Column
            field="userName"
            header="User Name"  
            style={{ width: "12%" }}
            sortable
          />
          <Column
            field="modifiedDate"
            header="Cancelled Date"
            style={{ width: "12%" }}
            sortable
            body={(rowData) => {
              const date = new Date(rowData.modifiedDate);
              const day = date.getDate().toString().padStart(2, "0");
              const month = date.toLocaleString("en-GB", { month: "long" });
              const year = date.getFullYear();
              return `${day} ${month} ${year}`;
            }}  
          />  
          <Column
            field="canceledUserName"
            header="Cancelled By"  
            style={{ width: "12%" }}
            sortable
          />
          <Column
            field="canceledPrimaryContactNbr"
            header="Cancelled By No"  
            style={{ width: "12%" }}
            sortable
          />
        </DataTable>
      </div>
    </div>
  );
};
 
export default CanceledOrderDatatable;
 
 